import axios from "axios";
import { SETTINGS } from "../../Settings";

export const AppEntryAttachmentRepository = {
  getDocument: (appEntryId, fileName) => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/appEntryAttachments/get/${appEntryId}/${fileName}`,
      method: "GET",
      responseType: "blob",
    });
  },
};
